<ng-container *ngIf="{on: (doNotDisturb$ | async) === true} as view">
    <button *ngIf="variant === 'icon'" type="button" class="dnd-toggle-icon" role="switch"
            [class.dnd-on]="view.on" [attr.aria-checked]="view.on" [attr.aria-label]="label"
            [attr.title]="tooltipOf(view.on)" (click)="onToggle()">
        <i class="far" [class.fa-bell-slash]="view.on" [class.fa-bell]="!view.on"></i>
    </button>
    <button *ngIf="variant === 'pill'" type="button" class="dnd-toggle-pill" role="switch"
            [class.dnd-on]="view.on" [attr.aria-checked]="view.on" [attr.title]="tooltipOf(view.on)"
            (click)="onToggle()">
        <i class="fa-solid" [class.fa-bell-slash]="view.on" [class.fa-bell]="!view.on"></i>
        <span class="dnd-toggle-label">{{ label }}</span>
        <span class="dnd-toggle-state">{{ view.on ? 'On' : 'Off' }}</span>
    </button>
</ng-container>
